// Abas do ensaio no NavBarHeader. Video, Making Of e Live só aparecem quando o
// ensaio tem esse conteúdo; as demais abas aparecem sempre. As flags `has*` vêm
// na resposta da API de qualquer aba (photos, videos, makingOf, lives...).
//
// Filtra por `path`, que é igual nos dois idiomas; o filtro antigo comparava o
// `name` traduzido.

export interface FlagsEnsaio {
  hasVideos?: unknown;
  hasMakingOf?: unknown;
  hasLives?: unknown;
}

const FLAG_DA_ABA: Record<string, keyof FlagsEnsaio> = {
  video: "hasVideos",
  "making-of": "hasMakingOf",
  live: "hasLives",
};

export function abasDoEnsaio<T extends { path: string }>(
  navBar: readonly T[],
  flags: FlagsEnsaio | null | undefined,
): T[] {
  return navBar.filter((aba) => {
    const flag = FLAG_DA_ABA[aba.path];
    return !flag || Boolean(flags?.[flag]);
  });
}
